import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Button, Form, FormGroup, FormCheckbox } from 'semantic-ui-react'
import { toast } from 'react-toastify'

import api from '~/services/api'

export default function FormTabulacao({ idDominio, idTabulacao }) {
  const [template, setTemplate] = useState('')
  const [useTemplate, setUseTemplate] = useState(false)
  const textAreaRef = useRef(null)

  const ajustarAltura = useCallback(() => {
    const textarea = textAreaRef.current
    if (textarea) {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }, [])

  const buscarTemplate = useCallback(async () => {
    try {
      const { data } = await api.get(
        `/tabulacao/domain/${idDominio}/${idTabulacao}`,
      )
      setTemplate(data.texto_template || '')
      setUseTemplate(data.use_template || false)
    } catch (error) {
      console.error('Erro ao buscar template:', error)
    }
  }, [idTabulacao, idDominio])

  const alterarTemplate = useCallback(async () => {
    try {
      const { data } = await api.get(
        `/tabulacao/domain/${idDominio}/${idTabulacao}`,
      )

      await api.put(`/tabulacao/domain/${idDominio}/${idTabulacao}`, {
        ...data,
        texto_template: template,
        use_template: useTemplate,
      })

      buscarTemplate()
      toast.success('Template alterado com sucesso')
    } catch (error) {
      console.error('Erro ao alterar template:', error)
    }
  }, [template, useTemplate, idDominio, idTabulacao, buscarTemplate])

  useEffect(() => {
    buscarTemplate()
  }, [buscarTemplate])

  // Sempre que o template mudar, ajusta a altura
  useEffect(() => {
    ajustarAltura()

    const ajustarAlturaInterval = setInterval(() => {
      ajustarAltura()
    }, 1000) // Ajusta a altura a cada segundo

    return () => {
      clearInterval(ajustarAlturaInterval)
    }
  }, [template, ajustarAltura])

  return (
    <Form className="attached fluid segment">
      <FormCheckbox
        inline
        label="Utilizar template ao selecionar tabulação"
        checked={useTemplate}
        onChange={(e, { checked }) => setUseTemplate(checked)}
      />
      <FormGroup widths="equal">
        <Form.Field width={16}>
          <label htmlFor="form-textarea-control-opinion">Template</label>
          <textarea
            id={`${idTabulacao}-template-textarea`}
            placeholder="Template"
            value={template}
            ref={textAreaRef}
            onChange={(e) => setTemplate(e.target.value)}
            style={{ overflow: 'hidden', resize: 'none' }}
          />
        </Form.Field>
      </FormGroup>

      <Button color="blue" size="mini" onClick={alterarTemplate}>
        Alterar
      </Button>
    </Form>
  )
}
